import { createSlice } from "@reduxjs/toolkit";

const PER_GAME_INITIAL = {
  state: null,
  result: null,
  bets: null,
};

const initialState = {
  dice: { ...PER_GAME_INITIAL },
  circle: { ...PER_GAME_INITIAL },
  colorPrediction: { ...PER_GAME_INITIAL },
  crash: { ...PER_GAME_INITIAL, coefficient: null },
  aviator: { ...PER_GAME_INITIAL, coefficient: null },
  roulette: { ...PER_GAME_INITIAL },

  activeGame: null,
  lastSettlement: null,
  allowedGames: [],
};

const GAME_TYPE_TO_KEY = {
  DICE: "dice",
  CIRCLE: "circle",
  COLOR_PREDICTION: "colorPrediction",
  CRASH: "crash",
  AVIATOR: "aviator",
  ROULETTE: "roulette",
};

export const inHouseSlice = createSlice({
  name: "inHouseData",
  initialState,
  reducers: {
    setGameState: (state, action) => {
      const { gameType, ...payload } = action.payload;
      const key = GAME_TYPE_TO_KEY[gameType] || gameType;
      if (state[key]) {
        state[key].state = payload;
      }
    },
    setGameResult: (state, action) => {
      const { gameType, ...payload } = action.payload;
      const key = GAME_TYPE_TO_KEY[gameType] || gameType;
      if (state[key]) {
        state[key].result = payload;
      }
    },
    setBetsActivity: (state, action) => {
      const { gameType, ...payload } = action.payload;
      const key = GAME_TYPE_TO_KEY[gameType] || gameType;
      if (state[key]) {
        state[key].bets = payload;
      }
    },
    setCrashCoefficient: (state, action) => {
      state.crash.coefficient = action.payload;
    },
    setAviatorCoefficient: (state, action) => {
      state.aviator.coefficient = action.payload;
    },
    setSettlement: (state, action) => {
      state.lastSettlement = action.payload;
    },
    clearSettlement: (state) => {
      state.lastSettlement = null;
    },
    setActiveGame: (state, action) => {
      state.activeGame = action.payload;
    },
    setAllowedInHouseGames: (state, action) => {
      state.allowedGames = action.payload;
    },
    clearGameState: (state, action) => {
      const gameType = action.payload;
      const key = GAME_TYPE_TO_KEY[gameType] || gameType;
      if (state[key]) {
        state[key].state = null;
        state[key].result = null;
        state[key].bets = null;
        if (key === "crash" || key === "aviator") {
          state[key].coefficient = null;
        }
      }
    },
    resetInHouse: () => initialState,
  },
});

export const {
  setGameState,
  setGameResult,
  setBetsActivity,
  setCrashCoefficient,
  setAviatorCoefficient,
  setSettlement,
  clearSettlement,
  setActiveGame,
  setAllowedInHouseGames,
  clearGameState,
  resetInHouse,
} = inHouseSlice.actions;

export default inHouseSlice.reducer;
